export default "https://studio-ui-deployments.apollographql.com/build/static/assets/dot-pattern.4db5a0c647b70912719d3521c272ffb0.png";